import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApiOutagePlaceholder({
  title,
  description
}) {
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: "350px",
    marginBlockStart: "1000",
    marginBlockEnd: "0",
    marginInline: "auto",
    "data-test-id": "external-error-message",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-charts",
        width: 100,
        height: 100,
        marginBlockEnd: "200"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "500",
        textAlign: "center",
        children: title
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: description
      })]
    })
  });
}
export default ApiOutagePlaceholder;